import { Button } from '@air/primitive-button';

import {
  RecentlyDeletedTableRow,
  type RecentlyDeletedTableRowProps,
} from '~/components/RecentlyDeleted/components/RecentlyDeletedTableRow';

export type RecentlyDeletedLibraryTableRowProps = Pick<
  RecentlyDeletedTableRowProps,
  'dateDeleted' | 'recoveryWindow' | 'deletedBy' | 'title' | 'style'
> & {
  icon?: string;
  onRecoverLibrary: () => void;
};

export const RecentlyDeletedLibraryTableRow = ({
  onRecoverLibrary,
  dateDeleted,
  recoveryWindow,
  deletedBy,
  title,
  style,
  icon,
}: RecentlyDeletedLibraryTableRowProps) => {
  return (
    <RecentlyDeletedTableRow
      actions={
        <Button appearance="ghost" className="-ml-2.5" onClick={onRecoverLibrary}>
          Recover
        </Button>
      }
      deletedBy={deletedBy}
      dateDeleted={dateDeleted}
      recoveryWindow={recoveryWindow}
      style={style}
      thumbnail={<div className="flex size-10 items-center justify-center text-20">{icon}</div>}
      title={title}
      type="library"
    />
  );
};
